import { defineMeta } from '@/registry/types';

export const menuMeta = defineMeta({
  name: 'Menu',
  level: 'molecule',
  category: 'navigation',
  classification: 'themed-mui',
  description: 'Popover list of actions anchored to a trigger. Themed MUI Menu.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Menu',
  muiDocs: 'https://mui.com/material-ui/react-menu/',
  a2uiEquivalent: 'Menu',
  importPath: '@/molecules/Menu',
  requiredProps: ['open', 'anchorEl', 'onClose'],
  optionalProps: ['anchorOrigin', 'transformOrigin'],
  supportedStates: ['open', 'closed', 'item-selected', 'disabled-item'],
  designTokens: ['colors', 'radius'],
  accessibility: ['Keyboard: arrows navigate, Esc closes; focus returns to trigger.'],
  usageExamples: ['<Menu anchorEl={el} open={open} onClose={close}><MenuItem>...</MenuItem></Menu>'],
  antiPatterns: ['Do not use Menu for primary navigation.'],
  mountsSurface: 'portal',
  llmSafe: true,
  whenToUse: ['Row/overflow action lists', 'Context menus'],
  whenNotToUse: ['Selecting form values (use Select)'],
});

export default menuMeta;
